<template>
  <div class="fixed inset-0 bg-[var(--color-bg)] overflow-hidden z-[999]">

    <!-- Skip 按鈕 -->
    <button
      class="absolute top-6 right-6 z-10 bg-transparent border border-[var(--color-border)] text-[var(--color-text-muted)] text-[0.7rem] tracking-[0.15em] px-[0.8rem] py-[0.3rem] cursor-pointer transition-[border-color,color] duration-200 hover:border-white/30 hover:text-[var(--color-text)]"
      @click="skip"
    >SKIP</button>

    <!-- 5 個部件圓圈（1-5） -->
    <div
      v-for="(part, i) in parts"
      :key="part"
      class="absolute top-1/2 left-1/2 pointer-events-none z-[1]"
      :ref="el => { if (el) circles[i] = el }"
    >
      <img :src="part" class="w-full h-full object-contain block" />
    </div>

    <!-- 第 6 張：完整蛇形 + 文字（掃光刷入） -->
    <div class="absolute top-1/2 left-1/2 pointer-events-none z-[1]" ref="ouroborosWrap">
      <img :src="ouroboros" class="w-full h-full object-contain block" />
    </div>

  </div>
</template>

<script>
import { gsap } from 'gsap'

const PARTS = [
  require('@/logo/1-body-left.svg'),
  require('@/logo/2-body-right.svg'),
  require('@/logo/3-hard.svg'),
  require('@/logo/4-tail.svg'),
  require('@/logo/5-eye.svg'),
]
const OUROBOROS = require('@/logo/6-ouroboros.svg')

export default {
  name: 'Splash',

  data() {
    return {
      parts: PARTS,
      ouroboros: OUROBOROS,
      circles: [],
      skipped: false,
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.runAnimation()
    })
  },

  methods: {
    skip() {
      if (this.skipped) return
      this.skipped = true
      gsap.killTweensOf('*')
      this.$emit('done')
    },

    runAnimation() {
      const circles = this.circles
      const oWrap = this.$refs.ouroborosWrap

      const W = window.innerWidth
      const H = window.innerHeight

      const usableH = H * 0.88
      const GAP_RATIO = 0.2
      const SIZE = usableH / (5 + GAP_RATIO * 4)
      const GAP = SIZE * GAP_RATIO
      const S = Math.min(SIZE, W * 0.18)

      gsap.set(circles, {
        opacity: 0, scale: 0, x: 0, y: 0,
        width: S, height: S,
        marginLeft: -S / 2, marginTop: -S / 2,
      })
      gsap.set(oWrap, {
        opacity: 0, clipPath: 'inset(0 100% 0 0)',
        width: S, height: S,
        marginLeft: -S / 2, marginTop: -S / 2,
      })

      const colX = W * 0.72 - W / 2

      const totalH = S * 5 + GAP * 4
      const topY = (H - totalH) / 2
      const targetYs = Array.from({ length: 5 }, (_, i) =>
        topY + i * (S + GAP) + S / 2 - H / 2
      )
      const lastY = targetYs[4]

      const tl = gsap.timeline({
        onComplete: () => {
          if (!this.skipped) this.$emit('done')
        },
      })

      const impactOffsetYs = [-H * 0.22, -H * 0.11, 0, H * 0.11, H * 0.22]
      const impactX = -W * 0.18
      const impactScale = (W * 0.85) / S
      const offsets = [0, 0.38, 0.76, 1.14, 1.52]

      for (let i = 0; i < circles.length; i++) {
        const t0 = offsets[i]
        tl.set(circles[i], { opacity: 1, x: 0, y: 0, scale: 0.15 }, t0)
          .to(circles[i], {
            x: impactX, y: impactOffsetYs[i], scale: impactScale,
            duration: 0.32, ease: 'power4.in',
          }, t0)
          .to(circles[i], {
            x: colX, y: targetYs[i], scale: 1,
            duration: 0.38, ease: 'power3.out',
          }, '<+0.42')
      }

      tl.to(circles, { y: lastY, duration: 0.5, ease: 'power2.inOut', stagger: 0 }, '+=0.12')

      const coverW = (H - 32) * 0.75 * 0.9
      const finalScale = Math.min(coverW / S, (W * 0.72) / S)
      const peakScale = finalScale * 1.08

      tl.to(circles, { x: 0, y: 0, scale: peakScale, duration: 0.55, ease: 'power2.inOut', stagger: 0 }, '+=0.2')
        .to(circles, { scale: finalScale, duration: 0.3, ease: 'back.out(1.2)' }, '<+0.45')

      tl.set(oWrap, { scale: finalScale }, '+=0.15')
        .to(oWrap, { opacity: 1, duration: 0.1 }, '<')
        .to(oWrap, { clipPath: 'inset(0 0% 0 0)', duration: 0.9, ease: 'power2.inOut' }, '<')

      tl.to([circles, oWrap], { scale: 0, opacity: 0, duration: 0.45, ease: 'power2.in' }, '+=0.5')
    },
  },
}
</script>
